import React from "react";
import { Container } from "react-bootstrap";

export const Collections: React.FC = () => {

    return(
        <React.Fragment>
            <Container fluid className="p-0">
                Collections
            </Container>
        </React.Fragment>
    );
}